<template>
    <modal
        :saveAction="saveAction"
        :title="title"
        :id="id"
        :actionButtons="false"
        size="lg"
        :closeButton="true"
        @shown="shown() "
    >
        <template slot="modal-header">
            <span></span>
        </template>
        <div class="row">
            <div class="col-4">
                <div class="card">
                    <div class="card-body">
                        <div class="row align-items-center active">
                            <div class="col-auto" v-if="serviceId === 'recent'">
                                <a href="#" @click.prevent="serviceId = null">
                                    <i class="fe fe-x"></i>
                                </a>
                            </div>
                            <div class="col ml-n2">
                                <h4 class="card-title mb-1">
                                    <a href="#" @click.prevent="serviceId = 'recent'">{{ $t('Recently used') }}</a>
                                </h4>
                            </div>
                        </div>
                        <hr/>
                        <div v-for="(service, index) in services" :key="index">
                            <div class="row align-items-center active">
                                <div class="col-auto" v-if="service._id === serviceId">
                                    <a href="#" @click.prevent="serviceId = null">
                                        <i class="fe fe-x"></i>
                                    </a>
                                </div>
                                <div class="col ml-n2">
                                    <h4 class="card-title mb-1">
                                        <a href="#" @click.prevent="serviceId = service._id">{{ service.label }}</a>
                                        <span class="badge badge-soft-primary ml-2">{{ service.totalTreatments }}</span>
                                    </h4>
                                </div>
                            </div>
                            <hr/>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-8">
                <div class="card mb-2">
                    <div class="col">
                        <!-- Search -->
                        <div class="row align-items-center">
                            <div class="col-auto pr-0">
                                <span class="fe fe-x text-muted" v-if="query" @click="query=null"></span>
                                <span class="fe fe-search text-muted" v-else></span>
                            </div>
                            <div class="col">
                                <!-- <input type="search" class="form-control form-control-flush search no-glow"> -->
                                <b-form-input
                                    v-model="query"
                                    class="no-glow search form-control-flush"
                                    :placeholder="$t('Search')"
                                ></b-form-input>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="card mb-2" v-for="(treatment, treatmentIndex) in treatments()" :key="treatmentIndex">
                    <div
                        @click="use(treatment);"
                        class="card-body d-flex justify-content-between align-items-center p-2 pointer hover"
                    >
                        <h4 class="card-title mb-1 name">
                            <i
                                class="fe fe-package mr-1"
                                v-b-tooltip
                                :title="$t('Includes services or products')"
                                v-if="treatment.bundle && treatment.bundle.length>0"
                            ></i>
                            <strong>{{ treatment.code }}</strong> - {{ treatment.label }}
                            <p class="text-muted small mb-0 mt-1">
                                {{ treatment.duration | duration }}
                                <money :value="treatment.price"></money>
                            </p>
                        </h4>

                        <button class="btn">
                            <i class="fe fe-chevron-right h1 p-0 m-0"></i>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </modal>
</template>

<script>
import Modal from "@/components/Modal.vue";
import Money from "@/components/Money.vue";
import { modalMixins } from '@/mixins/modal.js'
import { mapGetters, mapState, mapActions } from 'vuex';
import { icdMixins } from '@/components/ICD10/icd-mixins.js';
import duration from '@/filters/duration.js';

export default {
    name: 'treatment-browser-modal',
    props: ['id', 'saveAction', 'data', 'useAction'],
    mixins: [modalMixins, icdMixins],
    filters: { duration },
    components: {
        Money,
        Modal,
    },
    data() {
        return {
            query: null,
            breadcrumbs: [],
            hideForm: false,
            parentId: null,
            model: {
                language: 'russian'
            },
            title: 'Treatment',
            serviceId: null,
            areItemsLoading: false,
            treatmentQuery: {
                _id: { $ne: 'temp' },
                $sort: { code: 1 }
            }
        }
    },
    watch: {
        serviceId(newVal) {
            delete this.treatmentQuery.serviceId;
            delete this.treatmentQuery._id;
            if (newVal) {
                if (newVal == 'recent') {
                    this.treatmentQuery._id = { $in: this.user.recentTreatments };
                } else {
                    this.treatmentQuery.serviceId = newVal;
                }
            } else {
                delete this.treatmentQuery.serviceId;
            }

        },
        query(newVal) {
            if (newVal) {
                this.treatmentQuery.$or = [{ label: { $regex: newVal, $options: "i" } }]
            } else {
                delete this.treatmentQuery.$or;
            }

        }
    },
    computed: {
        ...mapGetters('service', { findServicesInStore: 'find' }),
        ...mapState('service', { areServicesLoading: 'isFindPending' }),
        ...mapState('treatment', { areTreatmentsLoading: 'isFindPending' }),
        ...mapGetters('treatment', { findTreatmentInStore: 'find' }),
        ...mapState('auth', ['user']),

        services() {
            return this.findServicesInStore({ $sort: { priority: 1 } }).data;
        },

        // treatments() {
        //     return this.findTreatmentInStore({ query: this.treatmentQuery }).data;
        // }

    },

    methods: {
        ...mapActions('users', { updateUser: 'patch' }),

        use(item) {

            this.updateUser([this.user._id, {
                $addToSet: {
                    recentTreatments: item._id
                }
            }, {}]);

            let data = JSON.parse(JSON.stringify(item));
            this.useAction(data);
            // this.$root.$emit('bv::hide::modal', this.id);
            this.$toasted.global.success({
                message: this.$t('Item has been added')
            });
        },
        getParents(parentId) {
            if (!parentId) return;
            this.get(parentId).then(item => {
                this.breadcrumbs.unshift(item);

                if (item.parentId) {
                    this.getParents(item.parentId);
                } else {
                    this.breadcrumbs.unshift({
                        label: 'Home',
                    });
                }
            });
        },
        shown() {
            /* Switch back to the first tab */
            this.serviceId = 'recent';
            this.query = null;
            this.queryItems();
        },
        treatments() {

            return this.findTreatmentInStore({ query: this.treatmentQuery }).data;
        },
    },

}
</script>
<style>
.pre-formatted {
    white-space: pre;
}
</style>
